import {Field} from 'formik';
import Form from 'react-bootstrap/Form';
import _ from 'lodash';
import React from 'react';

export const FormikSelectGroup = ({name, label, placeholderLabel, options, emptyValueLabel, disabled}) =>
    <Field name={name}>
        {({field, form}) => {
            return <Form.Group>
                {!placeholderLabel && <Form.Label>
                    {label}
                </Form.Label>}
                <Form.Control as="select" {...field}
                              disabled={disabled}
                              isInvalid={_.get(form.touched, field.name) && _.get(form.errors, field.name)}>
                    {placeholderLabel ?
                        <option value="">{label}</option>
                        :
                        <option value="">
                            {emptyValueLabel && emptyValueLabel}
                        </option>
                    }

                    {/* Es muss der index als key genommen werden, da nicht garantiert ist,
                        dass label oder value der choice eindeutig sind. */}
                    {options.map(({label, value}, index) => (
                        <option key={index} value={value}>{label}</option>
                    ))}
                </Form.Control>
                <Form.Control.Feedback type="invalid">
                    {_.get(form.errors, field.name)}
                </Form.Control.Feedback>
            </Form.Group>

        }}
    </Field>;
